import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Layout, Menu, Avatar, Dropdown, Row, Col, Modal, Tooltip } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import * as userActions from '../../redux/actions/userActions';
import { sideMenu, profileMenu } from './menu';
import Logo from '../../assets/images/Ansel-Adams-Logo-White.png';
import './main.less';
import { createButton, showButton, deleteRecord } from '../../common_functions';
import RestrictedPage from '../../../error/restrictedPage';
import PageNotFound from '../../../error/pageNotFound';
const extraProps = {
  createButton: createButton,
  showButton: showButton,
  deleteRecord: deleteRecord,
};
const { Header, Content, Sider } = Layout;

const MainLayout = props => {
  const navigate = useNavigate();
  const params = useParams();
  const history = { push: path => navigate(path), replace: path => navigate(path, { replace: true }) };
  props = { ...props, ...extraProps, history, match: { params } };
  const [siderCollapse, setSiderCollapse] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    let menuItem = props.match.params.menuItem;
    let roleType = props.roleType;
    roleType = roleType == 'admin' ? roleType : 'other_users';
    if (roleType && !menuItem) {
      let firstItem = sideMenu[roleType][0].key;
      props.history.push(firstItem);
    }
    let sec = props.match.params.section;
    if (sec != 'edit' && menuItem == 'print-objects') {
      window.onload = handlePageLoad;
    }
  }, []);

  const handlePageLoad = () => {
    localStorage.removeItem('print_sticky_filter');
    localStorage.removeItem('sticky_current_pagination');
    localStorage.removeItem('sticky_current_tab');
  };

  // antd's `breakpoint` calls this with an explicit boolean; the header button
  // calls it with a click event. Honour the boolean so a responsive collapse
  // sets the state instead of toggling it (which inverted on repeated resizes).
  const onSiderCollapse = collapsed => {
    setSiderCollapse(prev => (typeof collapsed === 'boolean' ? collapsed : !prev));
  };

  // On phones the expanded sider overlays the page, so close it once the user
  // picks a destination.
  const closeSiderOnPhone = () => {
    if (typeof window !== 'undefined' && window.innerWidth <= 575) setSiderCollapse(true);
  };
  const handleProfileMenu = async e => {
    if (e.key === 'sign-out') {
      try {
        await props.signOut();
      } catch (error) {
        // If there's an error during sign-out, log it for debugging purposes.
        console.error('Error during sign-out:', error);
      } finally {
        // Redirect to the login page, regardless of whether sign-out succeeded or not.
        props.history.replace('/login');
      }
    }
  };
  const renderComponent = (roleType, itemName, section, section_2, id) => {
    let componentProps = {
      history: props.history,
      match: props.match,
    };
    if (roleType) {
      roleType = roleType === 'admin' ? roleType : 'other_users';
      let compts = [];
      let collectionCondition = true;
      //prevent the users to view the collection and associted its negative and prints if they dont have permission to view the collections
      if (itemName != 'print-objects') {
        handlePageLoad();
      }

      if (roleType != 'admin' && id) {
        id = id != 'new' && parseInt(id) === NaN ? 0 : id;
        if (itemName == 'collections') {
          collectionCondition = props.collections_permissions.view.includes(parseInt(id));
        }
        if (section == 'negative-objects') {
          if (section_2 == 'list') {
            collectionCondition = props.collections_permissions.view.includes(parseInt(id));
          } else {
            collectionCondition =
              id === 'new' || section_2 === 'collection'
                ? props.tabs_permissions?.negatives?.create
                : props.prints_negatives_obj.includes(parseInt(id));
          }
        }
        if (itemName == 'print-objects') {
          if (section == 'list') {
            collectionCondition = props.collections_permissions.view.includes(parseInt(id));
          } else {
            // collectionCondition = props.prints_negatives_obj.includes(parseInt(id));
            collectionCondition =
              section === 'collection' ? props.tabs_permissions?.negatives?.create : props.prints_negatives_obj.includes(parseInt(id));
          }
        }
      }
      for (let index = 0; index < sideMenu[roleType].length; index++) {
        const value = sideMenu[roleType][index];
        if (value.key == itemName && (roleType == 'admin' || (props.tabs_access.includes(itemName) && collectionCondition))) {
          let hasChild = false;
          if (typeof value.component === 'function') {
            if (section && value?.children?.length > 0) {
              for (let childKey = 0; childKey < value.children.length; childKey++) {
                if (section == value.children[childKey].key) {
                  hasChild = true;
                }
              }
              if (!props.tabs_access.includes(section) && itemName === 'settings' && roleType !== 'admin') {
                compts.push(<RestrictedPage />);
                break;
              }
              if (!props.tabs_access.includes(section) && itemName === 'bibliography' && roleType !== 'admin') {
                compts.push(<RestrictedPage />);
                break;
              }
              if (!hasChild) {
                compts.push(<PageNotFound />);
                break;
              }
            }

            compts.push(value.component(props, section));
            break;
          }
          compts.push(value.component);
          break;
        }
        if (value.key == itemName && !props.tabs_access.includes(itemName) && roleType !== 'admin') {
          compts.push(<RestrictedPage />);
          break;
        }
      }
      if (compts.length == 0 && !collectionCondition) {
        compts.push(<RestrictedPage />);
      } else if (compts.length == 0) {
        compts.push(<PageNotFound />);
      }
      return compts.map((el, i) => (React.isValidElement(el) ? React.cloneElement(el, { key: el.key ?? i }) : el));
    } else {
      return '';
    }
  };

  const itemName = (roleType, menuItem) => {
    let menuItemName = '';
    if (roleType) {
      sideMenu[roleType].forEach(value => {
        if (value.key === menuItem) {
          menuItemName = value.name;
        }
      });
    }
    return menuItemName;
  };

  // Handler for open submenu change

  const render = () => {
    let user = props.user;
    let roleType = props.roleType;
    let menuItem = props.match.params.menuItem;
    let section = props.match.params.section;
    let section_2 = props.match.params.section_2;
    let id = props.match.params.id;
    let selectedKey = [menuItem];
    roleType = roleType == 'admin' ? roleType : 'other_users';
    const renderedContent = React.useMemo(
      () => (props.status.type == 'success' ? renderComponent(roleType, menuItem, section, section_2, id) : null),
      [props.status.type, roleType, menuItem, section, section_2, id]
    );
    roleType &&
      sideMenu[roleType].forEach(item => {
        if (item.key === menuItem) {
          if (item.children && item.children.length > 0) {
            let childItemKey = [];
            item.children.forEach(child => {
              if (child.children && child.children.length > 0) {
                const subChildFound = child.children.find(subChild => {
                  return subChild.key === section || subChild.key === id || subChild.key === section_2;
                });
                if (subChildFound) {
                  childItemKey.push(child.key);
                  childItemKey.push(subChildFound.key);
                }
              } else if (child.key === section || child.key === id) {
                childItemKey.push(child.key);
              }
            });
            selectedKey = [menuItem, ...childItemKey];
          } else {
            selectedKey = [menuItem];
          }
        }
      });

    const siderStyle = {
      overflow: 'auto',
      height: '100vh',
      position: 'sticky',
      insetInlineStart: 0,
      top: 0,
      bottom: 0,
      scrollbarWidth: 'thin',
    };
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          style={siderStyle}
          className="sider main-sidebar"
          breakpoint="lg"
          collapsed={siderCollapse}
          onCollapse={onSiderCollapse}
          width="230"
        >
          <div className="logo-img">
            <img src={Logo} alt="Ansel Adams" />
          </div>
          {/* <div className="logo-name">{!siderCollapse && user.first_name + ' ' + user.last_name}</div>
          {!siderCollapse && <div className="menu-title">Menu</div>} */}
          <Menu
            selectedKeys={selectedKey}
            defaultOpenKeys={selectedKey}
            className="menu"
            mode="inline"
            theme="dark"
            onClick={closeSiderOnPhone}
            items={
              roleType
                ? sideMenu[roleType].map(value => {
                    if (roleType == 'admin' || props.tabs_access.includes(value.key)) {
                      return {
                        ...value,
                        label: value.children ? (
                          <Tooltip title={siderCollapse ? '' : value.name} placement="right">
                            {value.name}
                          </Tooltip>
                        ) : (
                          <Tooltip title={siderCollapse ? '' : value.name} placement="right">
                            <Link to={'/' + value.key}>{value.name}</Link>
                          </Tooltip>
                        ),
                        children: value.children
                          ? value.children.map(item => {
                              if (
                                (value.key != 'settings' && value.key != 'bibliography') ||
                                props.tabs_access.includes(item.key) ||
                                roleType == 'admin'
                              ) {
                                return {
                                  ...item,
                                  label: item.children ? (
                                    <Tooltip title={siderCollapse ? '' : item.label} placement="right">
                                      {item.label}
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title={siderCollapse ? '' : item.label} placement="right">
                                      <Link to={'/' + value.key + '/' + item.key} title={item.label}>
                                        {item.label}
                                      </Link>
                                    </Tooltip>
                                  ),
                                  children: item.children
                                    ? item.children.map(subItem => {
                                        return {
                                          ...subItem,
                                          label: (
                                            <Tooltip title={siderCollapse ? '' : subItem.label} placement="right">
                                              <Link to={'/' + value.key + '/' + item.key + '/' + subItem.key} title={subItem.label}>
                                                {subItem.label}
                                              </Link>
                                            </Tooltip>
                                          ),
                                        };
                                      })
                                    : null,
                                };
                              }
                            })
                          : null,
                      };
                    }
                  })
                : []
            }
          ></Menu>
        </Sider>
        {/* Phone-only tap target to dismiss the overlaid sider (CSS hides it >=sm). */}
        {!siderCollapse && <div className="sider-backdrop" onClick={() => setSiderCollapse(true)} />}
        <Layout style={{ marginLeft: 0 }} className="content-layout">
          <Header className="header shadow">
            <Row gutter={[16, 16]}>
              <Col xs={3} sm={3} md={1}>
                {siderCollapse ? <MenuUnfoldOutlined onClick={onSiderCollapse} /> : <MenuFoldOutlined onClick={onSiderCollapse} />}
              </Col>
              <Col xs={10} sm={10} md={14}>
                {/* <div className='header-title'>{itemName(roleType, menuItem)}</div> */}
              </Col>
              <Col xs={11} sm={11} md={9}>
                <Row gutter={16} justify="end">
                  <Col className="right-header ant-row-end">
                    <Dropdown
                      menu={{
                        onClick: handleProfileMenu,
                        items: profileMenu.map(value => ({ key: value.key, label: value.name })),
                      }}
                    >
                      <div style={{ width: 'fit-content', cursor: 'pointer' }}>
                        <Avatar icon={<UserOutlined />} /> &nbsp;
                        <DownOutlined />
                      </div>
                    </Dropdown>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Header>
          {/* Margin lives in CSS (.app-content) so it can shrink on small screens;
              an inline style could not be overridden by a media query. */}
          <Content className="app-content" style={{ overflow: 'initial' }}>
            <Row>
              {props.status.type == 'success' && <Col span={24}>{renderedContent}</Col>}
            </Row>
          </Content>
        </Layout>
      </Layout>
    );
  };

  return render();
};

export default connect(state => {
  return {
    ...state.status,
    ...state.user,
  };
}, userActions)(React.memo(MainLayout));
